class ShowMoreSpecs extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;

    const contentDiv = this.querySelector('.product-specs__container');
    const button = this.querySelector('.show-button');
    const overlay = this.querySelector('.fade-overlay');

    const height = contentDiv.clientHeight;
    if (height > 350) {
      button.style.display = 'block';
      contentDiv.style.maxHeight = '350px';
    } else {
      button.style.display = 'none';
      overlay.style.display = 'none';
    }

    button.addEventListener('click', () => {
      if (this.isExpanded) {
        contentDiv.style.maxHeight = '350px';
        button.textContent = 'Show more';
        overlay.style.display = 'block';
      } else {
        contentDiv.style.maxHeight = '100%';
        button.textContent = 'Show Less';
        overlay.style.display = 'none';
      }
      this.isExpanded = !this.isExpanded;
    });
  }
}

// Define the custom element
customElements.define('showmore-specs', ShowMoreSpecs);
